module.exports = __webpack_public_path__ + "img/nikos_charge_logo.cca4afa9.png";